import { storage } from '@/services/storage'
import { s3Filesystem } from '@/services/axios'

export const app = {
    namespaced: true,
    state: {
        old_panel: false,
        datatableCancel: null,
        companiesRestricted: null
    },
    mutations: {
        SET_OLD_PANEL(state, payload){
            state.old_panel = payload
        },
        SET_DATATABLE_CANCEL(state, payload) {
            state.datatableCancel = payload
        },
        SET_COMPANIES_RESTRICTED(state, payload) {
            state.companiesRestricted = { ...payload }
        }
    },
    actions: {
        setOldPanel({ commit }, payload) {
            commit('SET_OLD_PANEL', payload)
            storage.set('old_panel', payload)
        },
        setDatatableCancel({ commit }, payload) {
            commit('SET_DATATABLE_CANCEL', payload)
        },
        /**
         * Seta uma lista contendo as instâncias que devem ser ignoradas pelo
         * Hotjar e Wootric
         *
         * @param {*} payload 
         */
        async setCompaniesRestricted({ commit }) {
            const response = await s3Filesystem.getCompaniesRestricted()
            commit('SET_COMPANIES_RESTRICTED', response.data)
        }
    }
}